import React, { useState } from 'react';

const PetSelector = ({ onSubmit }) => {
  const [hoveredPet, setHoveredPet] = useState(null);
  const [selectedPet, setSelectedPet] = useState(null);
  const [animate, setAnimate] = useState(false);

  const handlePetSelect = (petType) => {
    setSelectedPet(petType);

    // Add animation before submitting
    setAnimate(true);
    setTimeout(() => {
      onSubmit(petType);
    }, 500);
  };

  return (
    <div className="max-w-3xl mx-auto overflow-x-hidden">
      <div className="text-center mb-8 lg:mb-10">
        <h2 className="text-3xl sm:text-4xl font-bold text-purple-700 mb-3">Let's Get Started!</h2>
        <p className="text-lg lg:text-xl text-gray-600">Tell us what kind of furry friend you have</p>
      </div>
      
      <div className={`bg-white rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg transition-all duration-500 ${animate ? 'opacity-0 transform translate-x-10' : ''}`}>
        <div className="grid grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
          <button
            className={`relative overflow-hidden bg-gradient-to-br from-pink-400 to-pink-600 hover:from-pink-500 hover:to-pink-700 text-white py-8 px-5 sm:px-6 lg:py-12 rounded-2xl transition-all duration-300 transform ${hoveredPet === 'cat' ? 'scale-105' : ''} ${selectedPet === 'cat' ? 'ring-4 ring-pink-300 scale-105' : ''} shadow-md flex flex-col items-center`}
            onClick={() => handlePetSelect('cat')}
            onMouseEnter={() => setHoveredPet('cat')}
            onMouseLeave={() => setHoveredPet(null)}
          >
            <div className="absolute top-0 left-0 w-full h-full bg-white opacity-10 transform -skew-x-12 -translate-x-full transition-transform hover:translate-x-0 duration-700"></div>
            <span className="text-5xl sm:text-6xl mb-4">🐱</span>
            <span className="font-bold text-xl sm:text-2xl lg:text-3xl tracking-wide">Cat</span>
          </button>
          
          <button
            className={`relative overflow-hidden bg-gradient-to-br from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700 text-white py-8 px-5 sm:px-6 lg:py-12 rounded-2xl transition-all duration-300 transform ${hoveredPet === 'dog' ? 'scale-105' : ''} ${selectedPet === 'dog' ? 'ring-4 ring-blue-300 scale-105' : ''} shadow-md flex flex-col items-center`}
            onClick={() => handlePetSelect('dog')}
            onMouseEnter={() => setHoveredPet('dog')}
            onMouseLeave={() => setHoveredPet(null)}
          >
            <div className="absolute top-0 left-0 w-full h-full bg-white opacity-10 transform -skew-x-12 -translate-x-full transition-transform hover:translate-x-0 duration-700"></div>
            <span className="text-5xl sm:text-6xl mb-4">🐶</span>
            <span className="font-bold text-xl sm:text-2xl lg:text-3xl tracking-wide">Dog</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default PetSelector;
